import React from "react";
import OpTransReport from "./OpTransReports";
import Punctuality from "./Punctuality";
import LostTrainAvoidableUnavoidable from "./LostTrainAvoidableUnavoidable";
import LostTrain from "./LostTrain";
import PunctualityTrainWise from "./PunctualityTrainWise";
import PunctualityTrainDetentionCodeWise from "./PunctualityTrainDetentionCodeWise";
import PunctualityDetentionCodeWise from "./PunctualityDetentionCodeWise";
import PunctualityTrainDetentionCodeWise2 from "./PunctualityTrainDetentionCodeWise2";
import ReportMaster from "./PunctualityPerformance/PunctualitySummary/ReportMaster";

const PunctualityMaster = () => {
  return (
    <div className="">
      {/* ///////////////////////////////1st row /////////////////////////////// */}
      <div className="row p-2 d-flex align-items-stretch">
        <div className="col-md-8">
          <div className="Subject newUiBody h-100" style={{ fontSize: "12px" }}>
            <OpTransReport />
          </div>
        </div>
        <div className="col-md-4">
          <div className="Subject newUiBody h-100">
            <LostTrain />
          </div>
        </div>
      </div>
      <div
        className=" row p-2 "
        style={{ background: "rgba(174, 214, 241, 0.2)" }}
      >
        <div className="col-md-12 ">
          <div className="Subject ">
            {/* <Punctuality /> */}
            <ReportMaster />
          </div>
          {/* LOST TRAIN Avoidable and unavoidable table */}
          <div
            className="Subject  "
            style={{ background: "rgba(255, 255, 255, 0)" }}
          >
            <LostTrainAvoidableUnavoidable />
          </div>
        </div>
      </div>
      {/* ///////////////////////////////2nd row /////////////////////////////// */}
      <div className=" row mt-2 mt-2">
        <div className="col-md-12 ">
          <div className="Subject ">
            <PunctualityTrainDetentionCodeWise2 />
          </div>
        </div>
      </div>

      {/* ///////////////////////////////3nd row /////////////////////////////// */}

      {/* <div className=" row mt-2">
        <div className="col-md-12">
          <div className="Subject ">
            <PunctualityTrainDetentionCodeWise />
          </div>
        </div>
      </div> */}
      <div className=" row mt-2">
        <div className="col-md-7">
          <div className="Subject ">
            <PunctualityTrainWise />
          </div>
        </div>
        <div className="col-md-5">
          <div className="Subject ">
            <PunctualityDetentionCodeWise />
          </div>
        </div>
      </div>
    </div>
  );
};
export default PunctualityMaster;
